
export default function UserProfilePage() {
  return (
    <div className="pt-20 px-6">
      <h1 className="text-white text-4xl font-bold">User Profile</h1>
    </div>
  );
}